// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2hJqm","notes":"Notes_notes__Eh6AZ","note":"Notes_note__24z-t","markdown":"Notes_markdown__2cyiu"};